import React from "react";
import { getPathName } from "../../../utils/utilsFunc";
import { CGE } from "..";
import * as XLSX from "xlsx";

function ButtonExcelMultipleTable({ props }) {
  function encodeCell(row, column) {
    return XLSX.utils.encode_cell({ r: row, c: column });
  }

  function deleteRow(ws, rowIndex) {
    const variable = XLSX.utils.decode_range(ws["!ref"]);

    for (let R = rowIndex; R < variable.e.r; ++R) {
      for (let C = variable.s.c; C <= variable.e.c; ++C) {
        ws[encodeCell(R, C)] = ws[encodeCell(R + 1, C)];
      }
    }

    variable.e.r--;
    ws["!ref"] = XLSX.utils.encode_range(variable.s, variable.e);
  }

  function exportHandler(name, data, headers,nameTabs) {
    const wb = XLSX.utils.book_new();

    const ws1 = XLSX.utils.json_to_sheet([{}], {
      header: headers[0],
    });
    const ws2 = XLSX.utils.json_to_sheet([{}], {
      header: headers[1],
    });
    const ws3 = XLSX.utils.json_to_sheet([{}], {
      header: headers[2],
    });

    XLSX.utils.sheet_add_json(ws1, data[0], { origin: "A2" });
    XLSX.utils.sheet_add_json(ws2, data[1], { origin: "A2" });
    XLSX.utils.sheet_add_json(ws3, data[2], { origin: "A2" });

    XLSX.utils.book_append_sheet(wb, ws1, nameTabs[0]);
    XLSX.utils.book_append_sheet(wb, ws2, nameTabs[1]);
    XLSX.utils.book_append_sheet(wb, ws3, nameTabs[2]);

    deleteRow(ws1, 1);
    deleteRow(ws2, 1);
    deleteRow(ws3, 1);

    XLSX.writeFile(wb, `${name}.xlsx`, { bookType: "xlsx" });
  }

  return (
    <div>
      {props && props.auxArray && props.arTitles && (
        <CGE.Button
          id="btn-csv"
          label="Exportar Excel"
          disabled={props.disabled}
          onClick={() => {
            exportHandler(
              props?.fileName?props?.fileName:getPathName(),
              props.auxArray,
              getPathName() ==="reports"?props.arTitles:props.arTitles[getPathName()].map((el) => el.label),
              props?.nameTabs
            );
          }}
        />
    )}
    </div>

  );
}

export default ButtonExcelMultipleTable;
